import {Form} from "../../components/quickform/Model";
import {createForm} from "../../components/quickform/QuickForm";

export type LogisticsPartnerFormData = {
   name: string
   attention?: string | null
   address?: string | null
   address2?: string | null
   zipCode?: string | null
   city?: string | null
   country?: string | null
   countryCode?: string | null
   mail?: string | null
   phone?: string | null
   apiKey?: string | null
   apiSecret?: string | null
}

type LogisticsPartnerFormOptions = {
   title: string
   credentials?: boolean
   cancel?: boolean
}

export const createLogisticsPartnerForm = ({title, credentials, cancel}: LogisticsPartnerFormOptions): Form => {
   return createForm({
      layout: {
         type: "Vertical",
         children: [{
            type: "Heading",
            props: {
               text: title
            }
         }, {
            type: "TextField",
            props: {
               label: "Name",
               field: "name",
               required: true,
               focus: true
            }
         }, {
            type: "TextField",
            props: {
               label: "Attention",
               field: "attention"
            }
         }, {
            type: "TextField",
            props: {
               label: "Address",
               field: "address"
            }
         }, {
            type: "TextField",
            props: {
               label: "Address 2",
               field: "address2"
            }
         }, {
            type: "Horizontal",
            children: [{
               type: "TextField",
               props: {
                  label: "Zip code",
                  field: "zipCode"
               }
            }, {
               type: "TextField",
               props: {
                  label: "City",
                  field: "city"
               }
            }]
         }, {
            type: "Horizontal",
            children: [{
               type: "TextField",
               props: {
                  label: "Country",
                  field: "country"
               }
            }, {
               type: "TextField",
               props: {
                  label: "Country code",
                  field: "countryCode"
               }
            }]
         }, {
            type: "Horizontal",
            children: [{
               type: "TextField",
               props: {
                  label: "Email",
                  field: "mail",
                  type: "email"
               }
            }, {
               type: "TextField",
               props: {
                  label: "Phone",
                  field: "phone",
                  type: "tel"
               }
            }]
         }, ...(credentials ? [{
            type: "Heading",
            props: {
               text: "API credentials"
            }
         }, {
            type: "TextField",
            props: {
               label: "API key",
               field: "apiKey"
            }
         }, {
            type: "TextField",
            props: {
               label: "API secret",
               field: "apiSecret"
            }
         }] : []), {
            type: "Horizontal",
            props: {
               justify: "flex-end"
            },
            children: [{
               type: "Button",
               props: {
                  label: "Save",
                  type: "save"
               }
            }, ...(cancel ? [{
               type: "Button",
               props: {
                  label: "Cancel",
                  type: "cancel"
               }
            }] : [])]
         }]
      }
   });
}
